exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".check-org-users-list table.table {\n  table-layout: fixed;\n}\n.check-org-users-list table.table > tbody > tr > td,\n.check-org-users-list table.table > thead > tr > th {\n  padding: 8px 16px !important;\n}\n.check-org-users-list table.table tr {\n  cursor: pointer;\n}\n", ""]);

